//
// Copyright 2026 DXOS.org
//
import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import * as RpcGroup from 'effect/rpc/RpcGroup';
import * as Schema from 'effect/Schema';
import { InvitationSchema } from './buf/proto/gen/dxos/client/invitation_pb.js';
import { QueryInvitationsResponseSchema } from './buf/proto/gen/dxos/client/services_pb.js';
import { DeviceProfileDocumentSchema } from './buf/proto/gen/dxos/halo/credentials_pb.js';
import { bufMessage, serviceError } from './service-rpc.js';
//
// RPC message schemas.
//
export const AcceptInvitationRequest = Schema.Struct({
    invitation: bufMessage(InvitationSchema),
    deviceProfile: Schema.optional(bufMessage(DeviceProfileDocumentSchema)),
});
export const AuthenticationRequest = Schema.Struct({
    invitationId: Schema.String,
    authCode: Schema.String,
});
export const CancelInvitationRequest = Schema.Struct({
    invitationId: Schema.String,
});
/**
 * Effect RPC definitions for `dxos.client.services.InvitationsService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('createInvitation', {
    payload: bufMessage(InvitationSchema),
    success: bufMessage(InvitationSchema),
    error: serviceError,
    stream: true,
}), Rpc.make('acceptInvitation', {
    payload: AcceptInvitationRequest,
    success: bufMessage(InvitationSchema),
    error: serviceError,
    stream: true,
}), Rpc.make('authenticate', {
    payload: AuthenticationRequest,
    error: serviceError,
}), Rpc.make('cancelInvitation', {
    payload: CancelInvitationRequest,
    error: serviceError,
}), Rpc.make('queryInvitations', {
    success: bufMessage(QueryInvitationsResponseSchema),
    error: serviceError,
    stream: true,
})).prefix('InvitationsService.') {
}
/**
 * Effect service tag for the `InvitationsService` RPC handlers.
 */
export class Tag extends Context.Service()('@dxos/protocols/rpc/InvitationsService') {
}
//# sourceMappingURL=InvitationsService.js.map